export enum BorrowerCompanyVariable {
  CompanyName = 'companyName1',
  CompanyMappingId = 'companyMappingId1',
  SecondCompanyName = 'companyName2',
  SecondCompanyMappingId = 'companyMappingId2',
  ThirdCompanyName = 'companyName3',
  ThirdCompanyMappingId = 'companyMappingId3',
  IncomeW2Type1 = 'incomeW2Type1',
  IncomeW2Type2 = 'incomeW2Type2',
  IncomeW2Type3 = 'incomeW2Type3',
}
